export enum LangType {
  Spanish = 1,
  English,
  Italian,
}
